import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Search } from 'components/common';
import { Filters, FiltersActive } from 'components/common/filter';
import { DropdownSelectable } from 'components/common/dropdown';

const PathParticipantsSubHeader = () => {
  const { messages } = useReduxState();

  const router = useRouter();

  return (
    <>
      <div className="sub-header">
        <div className="filters">
          <div className="search">
            <Search
              onSearch={({ search }) => {
                router.replace({ query: { ...router.query, search, page: 1 } });
              }}
              placeholder={messages.usersSearchUsers}
            />
          </div>

          <Filters
            allowMultiple={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              supervisors: true,
              userAttributes: true
            }}
            filterId="path-participants"
            filters={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              supervisors: true,
              userAttributes: true
            }}
            customFilters={[
              {
                allowMultiple: false,
                field: 'completionStatus',
                icon: 'certificate',
                title: messages.commonCompletion,
                items: [
                  { label: messages.commonCompleted, value: 'yes' },
                  { label: messages.tasksUsersNotCompleted, value: 'no' }
                ],
                position: 4
              },
              {
                allowMultiple: false,
                field: 'pathAccess',
                icon: 'door-open',
                title: messages.commonAccess,
                items: [
                  {
                    label: messages.commonAccessCurrentParticipants,
                    value: 'current'
                  },
                  {
                    label: messages.commonAccessFormerParticipants,
                    value: 'former'
                  }
                ],
                position: 3
              }
            ]}
          />
        </div>

        <DropdownSelectable<'default' | 'steps'>
          category="lighter"
          defaultText={`${messages.commonView}:`}
          defaultValue="default"
          dropdownTextMinWidth="120px"
          onChange={(view) => {
            const query = { ...router.query, view };
            router.replace({ query }, { query }, { shallow: true });
          }}
          options={[
            { text: messages.commonDefault, value: 'default' },
            { text: messages.pathsSteps, value: 'steps' }
          ]}
          selectedValueBefore={`${messages.commonView}:`}
          showSelectedText={true}
          size="header"
          titleMaxWidth={120}
          value={(router.query?.view || 'default') as 'default' | 'steps'}
        />
      </div>

      <FiltersActive filterId="path-participants" />

      <style jsx>{`
        .sub-header {
          align-items: center;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 10px;
          width: 100%;
        }
        .filters {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 10px;
        }
        @media (min-width: ${breakpoints.small}px) {
          .search :global(input) {
            min-width: 240px;
          }
        }
      `}</style>
    </>
  );
};

export default PathParticipantsSubHeader;
